import {LocalPlayerContext} from '../offline/LocalPlayerContext';
import { useEffect, useState, useContext } from 'react';
const {DAILY_BADGES}=require('./dailyBadges');
const {getApiUrl}=require('../config/serverEndpoint');
const { ACHIEVEMENTS, achievementProgress } = require('./achievements');

export default function useShowcasedBadge(username) {
  const local=useContext(LocalPlayerContext);
  const [badge, setBadge] = useState(null);
  useEffect(() => {
    setBadge(null);
    if (local || !username) return undefined;
    let active = true,revision=0;
    const load=()=>{const request=++revision;return Promise.all([fetch(getApiUrl(`/get-player-stats?username=${encodeURIComponent(username)}`)), fetch(getApiUrl('/leaderboard'))])
      .then(async ([statsResponse, boardResponse]) => {
        if (!statsResponse.ok || !boardResponse.ok) return;
        const stats = await statsResponse.json();
        const board = await boardResponse.json();
        const result = ACHIEVEMENTS.find(item => item.id === stats.showcasedBadge && achievementProgress(item, stats, board.records).earned);
        const daily=DAILY_BADGES.find(b=>b.id===stats.showcasedBadge&&stats.dailyBadges?.[b.id]?.count>0);
        if (active&&request===revision) setBadge(daily?.name || result?.title || null);
      }).catch(() => { if (active&&request===revision) setBadge(null); });};
    const refresh=e=>{if(e.detail?.username===username)load();};load();window.addEventListener('kelimo-badges-updated',refresh);
    return () => { active = false;window.removeEventListener('kelimo-badges-updated',refresh); };
  }, [username,local]);
  return local ? local.players?.[String(username).toLowerCase()]?.showcasedBadge || null : badge;
}
